import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import ColorPane from 'src/components/global-settings/ColorPane'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    colors: state.vehicleCreateOptions.colors
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ColorPane)



// WEBPACK FOOTER //
// ./src/containers/global-settings/ColorPane.ts